<template>
  <cTable ref="table">
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          :label="item.name"
          :name="item.type"
          v-for="item in tabList"
          :key="item.type"
        />
      </Tabs>
      <component :is="tabName" collect class="page-height" />
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import bill from "../bill/index";
import hw_bill from "../hw_bill/index";
import cod_list from "../cod-list/index";
import cod_refund from "../cod-refund/index";
import b2b_bill from "../b2b_bill/index";
import collect from "./collect";
import location_bill from "../location_bill/index";
import storage_bill from "../storage_bill/index";
import other_fee_blii from "@/view/branch_finance/other_fee_bill/index";
import claim_fee from "@/view/claim_management/claim_fee/index";
import vat_bill from "../vatBill/index";

export default {
  name: "summaryBill",
  components: {
    cTable,
    bill,
    hw_bill,
    cod_list,
    cod_refund,
    b2b_bill,
    collect,
    location_bill,
		storage_bill,
    claim_fee,
		other_fee_blii,
		vat_bill
  },
  methods: {
    handleTab(tab) {
      this.$route.meta.id = this.tabList.find((item) => item.type === tab).id;
    },
  },
  async mounted() {
    this.$route.meta.id = 951;
  },
  data() {
    return {
      // config: {
      //   style: {
      //     height: ~"clac(100% - 40px)"
      //   }
      // },
      tabName: "collect",
      tabList: [
        {
          name: this.$t("summaryBill"),
          type: "collect",
          id: 951,
        },
        {
          name: this.$t("bill"),
          type: "bill",
          id: 25,
        },
        {
          name: this.$t("hwBill"),
          type: "hw_bill",
          id: 565,
        },
        {
          name: this.$t("codList"),
          type: "cod_list",
          id: 215,
        },
        {
          name: this.$t("codRefund"),
          type: "cod_refund",
          id: 216,
        },
        {
          name: this.$t("b2bBill"),
          type: "b2b_bill",
          id: 230,
        },
        {
          name: this.$t("location_bill"),
          type: "location_bill",
          id: 970,
        },
        {
          name: this.$t("claim_fee"),
          type: "claim_fee",
          id: 1006,
        },
				{
				  name: this.$t("other_fee_bill"),
				  type: "other_fee_blii",
				  id: 1452,
				},
				{
				  name: this.$t("storageBill"),
				  type: "storage_bill",
				  id: 1587,
				},
				{
				  name: this.$t("VAT账单"),
				  type: "vat_bill",
				  id: 1560,
				},
      ],
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("order_number"),
          copy: true,
          key: "airway_number",
          fixed: "left",
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              this.$page.getModal("showDetails").open({ row }, function () {
                this.setTitle(row.airway_number);
              });
            },
          },
          width: 160,
        },
        {
          name: () => this.$t("salesman"),
          key: "staffAccount",
          align: "left",
          minWidth: 110,
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "clientServiceAccount",
          align: "left",
          minWidth: 110,
        },
        {
          name: () => this.$t("clientName"),
          key: "customerAccount",
          align: "left",
          minWidth: 110,
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          align: "left",
          minWidth: 110,
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          minWidth: 80,
        },
        {
          name: () => this.$t("tracker_description"),
          key: "status_remarks",
          minWidth: 110,
        },
        // {
        //   name: () => this.$t("tracker_description_cn"),
        //   key: "status_cn",
        //   align: "left",
        //   minWidth: 110
        // },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          minWidth: 110,
        },
        {
          name: () =>
            this.$t("whether") + this.$t("confirm") + this.$t("Weight"),
          key: "isConfirmed",
          minWidth: 110,
        },
        {
          name: () => this.$t("company"),
          key: "consignee",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country_title",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("target_country"),
          key: "target_country_title",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("dingcangCompany"),
          key: "dingcang_company",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("method_name"),
          key: "transport_name",
          minWidth: 80,
        },
        {
          name: () => this.$t("invoicePCS"),
          key: "quantity",
          minWidth: 80,
        },
        {
          name: () => this.$t("charge_params") + "(KG)",
          key: "charging_weight",
          minWidth: 120,
        },
        {
          name: () => this.$t("charging_volume") + "(CBM)",
          key: "charging_volume",
          minWidth: 120,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("dept_HK") + this.$t("time"),
          key: "depart_port_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("arrival_HK") + this.$t("time"),
          key: "landed_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("clearance_date"),
          key: "clearance_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("pod") + this.$t("time"),
          key: "signed_time",
          minWidth: 170,
        },
        // {
        //   name: () => this.$t("cod_status"),
        //   key: "dbl_status_txt",
        //   minWidth: 100
        // },

        // {
        //   name: () => this.$t("order_address"),
        //   key: "consignee_address",
        //   minWidth: 150
        // },
        // {
        //   name: () => this.$t("order_phone"),
        //   key: "consignee_cellular",
        //   minWidth: 140
        // },
        // {
        //   name: () => this.$t("Remarks"),
        //   key: "remarks",
        //   minWidth: 110
        // },
        // {
        //   name: () => this.$t("order_userRef"),
        //   key: "client_refer_code",
        //   minWidth: 110
        // },
        // {
        //   name: () => this.$t("print") + this.$t("time"),
        //   key: "print_time",
        //   minWidth: 130
        // },
        {
          type: "btns",
          width: 620,
          name: () => this.$t("operation"),
          fixed: "right",
          headerAlign: "center",
          align: "left",
          btnBind: {
            type: "primary",
            size: "small",
            transfer: true,
          },
          list: [
            {
              name: () => this.$t("trajectory"),
              type: "showStatus",
              fnName: "showStatus",
              // bind: {
              //   type: "success"
              // }
            },
            {
              name: () => this.$t("unpack"),
              type: "unpack",
              fnName: "unpack",
              id: 548,
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("inbound"),
              type: "inbound",
              fnName: "inbound",
              id: 327,
              bind: {
                type: "info",
              },
              afterIcon({ row }) {
                return row.inboundStatus ? "md-checkbox" : "ios-square";
              },
            },
            {
              name: () => this.$t("out"),
              type: "outbound",
              fnName: "outbound",
              id: 434,
              bind: {
                type: "warning",
              },
              afterIcon({ row }) {
                return row.outboundStatus ? "md-checkbox" : "ios-square";
              },
            },
            {
              name: () => this.$t("doubleFeright"),
              type: "info",
              fnName: "info",
              // id: 196,
              bind: {
                type: "success",
              },
              afterIcon({ row }) {
                return row.confirmed_time > 0 ? "md-checkbox" : "ios-square";
              },
            },
            {
              name: () => this.$t("bindFreight"),
              type: "freight",
              fnName: "freight",
              id: 197,
              bind: {
                type: "error",
              },
              afterIcon({ row }) {
                return row.finance_time > 0 ? "md-checkbox" : "ios-square";
              },
            },
            {
              name: () => this.$t("sheet"),
              type: "sheet",
              id: 194,
              // fnName: "sheet",
              btnBind: {
                type: "primary",
                size: "small",
              },
              list: [
                {
                  name: () => this.$t("mini") + this.$t("size"),
                  type: "mini",
                  fnName: "sheet",
                },
                {
                  name: () => this.$t("standard") + this.$t("size"),
                  type: "a4",
                  fnName: "sheet",
                },
              ],
            },
            {
              name: () => this.$t("modify") + this.$t("CTNS"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$t("boxOrder"),
              type: "packList",
              fnName: "packList",
              id: 430,
              bind: {
                type: ({ row }) => {
                  return row.hasBox
                    ? row.hasBox === 2
                      ? "success"
                      : "error"
                    : "default";
                },
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 556,
            },
          ],
          methods: {
            showStatus({ row }) {
              this.getModal("showStatus").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("trajectory") + ")"
                );
              });
            },
            unpack({ row }) {
              this.getModal("showUnpack").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("unpack") + ")"
                );
              });
            },
            info({ row }) {
              this.getModal("showInfo").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("doubleFeright") + ")"
                );
              });
            },
            freight({ row }) {
              this.getModal("showFreight").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("bindFreight") + ")"
                );
              });
            },
            sheet({ row, field }) {
              printDouble({ id: row.airway_number, type: field.type }).then(
                (res) => {
                  if (res.data.status) {
                    window.open(
                      this.$globalUrl + res.data.data[0].url,
                      "_blank"
                    );
                  } else {
                    this.$Message["error"]({
                      background: true,
                      content: res.data.msg,
                    });
                  }
                }
              );
            },
            inbound({ row }) {
              this.getModal("showInbound").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("inbound") + ")"
                );
              });
            },
            outbound({ row }) {
              this.getModal("showOutbound").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("outbound") + ")"
                );
              });
            },
            update({ row }) {
              this.getModal("update").open({ row }, function () {
                this.setTitle(
                  row.airway_number +
                    "(" +
                    this.$t("modify") +
                    this.$t("CTNS") +
                    ")"
                );
                this.$page
                  .handleRequestMethods(
                    "getGoodsInfo",
                    row.airway_number,
                    false,
                    true
                  )
                  .then((res) => {
                    this.list = res.payload;
                  });
              });
            },
            async packList({ row }) {
              let res = await this.handleRequestMethods("getPackList", {
                id: row.airway_number,
              });
              let data = res.payload.deliver ? res.payload.deliver : {};
              data["id"] = row.airway_number;
              data["file"] = null;
              data["is_solely"] =
                res.payload.deliver.is_solely === "YES"
                  ? this.$t("YES")
                  : this.$t("NO");
              data["is_verify"] = res.payload.deliver.is_verify;
              // console.log(data);
              this.getModal("showPack").open(data, function () {
                this.list = res.payload.rows;
                this.pageConfig.data["id"] = row.airway_number;
                // this.$page.openLoading();
                // console.log("打开箱单", this);
                // this.pageConfig.loading = true;
                // this.$page
                //   .handleRequestMethods("getPackList", row.airway_number)
                //   .then(res => {
                //     this.list = res.payload.list;
                //     this.pageConfig.loading = false;
                //   });
                this.setTitle(
                  row.airway_number + "(" + this.$t("boxOrder") + ")"
                );
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.airway_number).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.page-height {
  height: ~"calc(100vh - 230px)" !important;
}
</style>
